import ClientVehicleTypes from "./components/ClientVehicleTypes/ClientVehicleTypes"

export const ScreenTypes = {
    ASSET_TYPE: 11
}

export const screenTypeAdditionalComponent = (clientId) => ({
    [ScreenTypes.ASSET_TYPE]: <ClientVehicleTypes clientId={clientId} />
})